<template>
  <div class='EnbTitlePage'>
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'EnbTitlePage',
  props: {
    text: {
      type: String,
      default: 'Text'
    }
  }
}
</script>

<style scoped>
.EnbTitlePage {
  padding-top: 2%;
  font-weight: bold;
  font-size: 22px;
}
</style>
